"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFilterPanel = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponents2 = require("../common/styled-components");

var _templateObject;

var StyledFilterPanel = (0, _styledComponents["default"])(_styledComponents2.PanelLabel)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: 500;\n  color: white;\n  flex: 1;\n"])));
exports.StyledFilterPanel = StyledFilterPanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9maWx0ZXJzL2NvbXBvbmVudHMudHMiXSwibmFtZXMiOlsiU3R5bGVkRmlsdGVyUGFuZWwiLCJQYW5lbExhYmVsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7O0FBRU8sSUFBTUEsaUJBQWlCLEdBQUcsa0NBQU9DLDZCQUFQLENBQUgsMElBQXZCIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdzdHlsZWQtY29tcG9uZW50cyc7XG5pbXBvcnQge1BhbmVsTGFiZWx9IGZyb20gJy4uL2NvbW1vbi9zdHlsZWQtY29tcG9uZW50cyc7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRGaWx0ZXJQYW5lbCA9IHN0eWxlZChQYW5lbExhYmVsKWBcbiAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgY29sb3I6IHdoaXRlO1xuICBmbGV4OiAxO1xuYDtcbiJdfQ==